import React from 'react';
import VendorProfile from '../ReusableComponents/VendorProfile/VendorProfile';
import {
  User,
  VendorProfileFormDataPreSubmit,
} from '../ReusableComponents/VendorProfile/types';
import { useUpdateVendorInfo } from '../../Lib/Hooks/vendor-onboarding.hooks';
import toast from '../Toast/Toast';

export type VendorApplication = {
  vendorInfo: {
    merch_type: string;
    existing_vendor: boolean;
    sponsor_id: string;
    requester_id: string;
    creator?: string;
  };
  id: string;
  answers: Record<string, unknown>[];
};

export interface VendorApplicationBuyerEditModalProps {
  currentUser: User;
  vendorApplication: VendorApplication;
  formData: Record<string, string>;
  onClose: () => void;
}

function VendorApplicationBuyerEditModal({
  currentUser,
  vendorApplication,
  formData,
  onClose,
}: VendorApplicationBuyerEditModalProps) {
  const save = useUpdateVendorInfo();

  return (
    <VendorProfile
      title="Edit Vendor Profile"
      creatorName={vendorApplication.vendorInfo.creator || undefined}
      onError={() => {
        toast({ title: 'Fields are empty or incorrect.' }, { type: 'error' });
      }}
      existingFormData={{
        primary_contact_email: formData.emailAddress,
        vendor_type_category: vendorApplication.vendorInfo.merch_type,
        existing_vendor:
          vendorApplication.vendorInfo.existing_vendor?.toString() || 'false',
        legal_name: formData.entityLegalName,
        doing_business_as: formData.doingBusinessAs,
        primary_contact_firstname: formData.firstName,
        primary_contact_lastname: formData.lastName,
        primary_contact_title:
          (vendorApplication.answers.find(
            (answer) => answer.question === 'title',
          )?.answer as string) || '',
        divisions: formData.divisionCategories
          ? (formData.divisionCategories as unknown as string[])
          : [],
        sponsor_id: Number(vendorApplication.vendorInfo.sponsor_id),
        requester_id: Number(vendorApplication.vendorInfo.requester_id),
      }}
      isLoading={false}
      handleSubmit={(data: VendorProfileFormDataPreSubmit) => {
        save.mutate(
          {
            id: vendorApplication.id,
            data: {
              sponsor_id: data.sponsor_id,
              existing_vendor: data.existing_vendor,
              legal_name: data.legal_name,
              doing_business_as: data.doing_business_as,
              divisions: data.divisions,
              primary_contact_firstname: data.primary_contact_firstname,
              primary_contact_lastname: data.primary_contact_lastname,
              primary_contact_title: data.primary_contact_title,
            },
          },
          {
            onSuccess: () => {
              toast(
                { title: 'Vendor successfully saved.' },
                { type: 'success' },
              );
              onClose();
            },
            onError: (error) => {
              toast({ title: 'Error saving vendor.' }, { type: 'error' });
              console.error('error while saving vendor', error);
            },
          },
        );
      }}
      submitText="Save"
      currentUser={currentUser}
      editMode
    />
  );
}

export default VendorApplicationBuyerEditModal;
